import { render, staticRenderFns } from "./VSeoForm.vue?vue&type=template&id=ecb16ab6"
import script from "./VSeoForm.vue?vue&type=script&lang=js"
export * from "./VSeoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports